import Bugsnag, { Event as ErrorEvent } from "@bugsnag/js";
import BugsnagPluginReact, {
  BugsnagErrorBoundary,
} from "@bugsnag/plugin-react";
import BugsnagPerformance from "@bugsnag/browser-performance";
import { HTTPError } from "fetch-run";
import React, { ComponentProps } from "react";

import { Env } from "../env";

function onError(event: ErrorEvent) {
  const error = event.errors[0];
  const status =
    (error as unknown as HTTPError | null)?.response?.status ?? null;

  if (status === 401 || status === 403 || status === 422) {
    return false; // Do not log
  }

  return true; // Log
}

Bugsnag.start({
  apiKey: Env.bugsnagApiKey,
  plugins: [new BugsnagPluginReact()],
  onError,
});

BugsnagPerformance.start({
  apiKey: Env.bugsnagApiKey,
});

type Props = ComponentProps<BugsnagErrorBoundary>;

function PassThroughErrorBoundary(props: Props) {
  return <>{props.children}</>;
}

export const ErrorBoundary =
  Bugsnag.getPlugin("react")?.createErrorBoundary(React) ??
  PassThroughErrorBoundary;
